import React from 'react'
import { useTheme } from '../Context/ThemeContext';
import Layout from '../Layout'
import Typewriter from "typewriter-effect";
import ImageSvg from '../Components/ImageSvg';

function Home() {

    const { primaryColor, secondaryColor, colors, theme, selectedColor } = useTheme();

    return (
        <Layout>
            <div className="md:mx-4 md:mt-10 grid grid-cols-1 md:grid-cols-2" data-aos="fade-up">
                <div className="mt-5 order-2 md:order-1 text-center md:text-left">
                    <div className="p-3">
                        <h1 className={`font-extrabold py-3 text-4xl dark:${secondaryColor} selection:${colors[theme].colors[selectedColor].bgPrimary}`}>
                            Hi, I'am Pranesh
                        </h1>
                        <span className={`font-semibold py-3 ${primaryColor} dark:${primaryColor}`}>
                            <Typewriter
                                options={{
                                    loop: true,
                                }}
                                onInit={(typewriter) => {
                                    typewriter
                                        .typeString("Full stack developer")
                                        .pauseFor(2000)
                                        .deleteAll()
                                        .typeString("Freelancer")
                                        .pauseFor(2000)
                                        .deleteAll()
                                        .start();
                                }}
                            />
                        </span>
                        <p className={`py-3 ${primaryColor} dark:${primaryColor}`}>
                            I’m a software engineer specializing in building web applications.
                        </p>
                    </div>
                </div>
                <div className="mt-5 flex justify-center order-1 md:order-2">
                    <ImageSvg />
                </div>
            </div>
        </Layout>
    )
}

export default Home